// 扫描发货
import OrderDTO from "@/dto/order/OrderDTO";
import LogisticsCompany from "@/enum/LogisticsCompany";
import { post } from "@/services/http/platformServer";
import { OrderShipParams } from "../orderShip";
import OrderConsigneeDTO from "@/dto/order/OrderConsigneeDTO";

export interface ScanShippingGetOrderResult {
    logisticsCompany: LogisticsCompany;
    orders: OrderDTO[];
    waybillNo?: string;
}

/**
 * 通过运单号查询订单信息
 *
 * 如果用户扫描发货时勾选『先显示订单商品信息核对后再发货』选项， 对每一个关联在一起的店铺循环调用该接口获取订单（只要其中一个店铺匹配到订单就中断循环）
 * 如果运单号在所有店铺都不存在的话，在下方的扫描结果提示『找不到相应的待发货订单，请先打印电子面单或录运单号』。
 * 可能会返回待发货、已发货、已取消订单,前端展现所有订单及订单状态，但是点击发货时只对待发货调发货接口，该接口也会先检查订单状态如果订单不符合发货条件会报错
 * 如果包含不符合发货条件的订单会报错，前端需要在下方扫描发货结果用红色文字展现错误
 */
export function getOrdersByWaybillNo(shopIds: number[], waybillNo: string) {
    const shopId = shopIds[0];

    return post<ScanShippingGetOrderResult>(shopId, "/scan_shipping/get_orders_by_waybill_no", {
        shopIds,
        waybillNo,
    });
}

export enum ScanShippingResultStatus {
    FAIL = "FAIL",
    /** 多包裹发货部分运单号发货失败 */
    MULTI_PKG_SHIP_PART_FAIL = "MULTI_PKG_SHIP_PART_FAIL",
    SUCCESS = "SUCCESS",
}

export interface ScanShippingResultError {
    buyerNickname?: string;
    buyerUsername?: string;
    logisticsCompany?: LogisticsCompany;
    message?: string;
    orderId?: number;
    orderOriginalId?: string;
    waybillNo?: string;
}

interface PackageInfo {
    /**
     * 商品信息(如果为空表示为包含整单商品)
     */
    items?: { orderItemOriginalId: string; quantity: number }[];
    logisticsCompany: LogisticsCompany;
    parentWaybillNo?: string;
    waybillNo: string;
    waybillNoCategory?: "STANDARD" | "PARENT" | "CHILD";
}

export interface ScanShippingResult {
    /**
     * 前端值
     * 扫描的运单号
     */
    waybillNo: string;

    /**
     * 前端值
     * 搜索出来的订单收货人信息
     */
    consignee: OrderConsigneeDTO;

    /**
     * 前端值
     * 操作发货的时间
     */
    operateShipmentTime?: string;

    /**
     * 错误列表
     */
    errors?: ScanShippingResultError[];
    /**
     * 订单ID
     */
    orderId?: number;
    /**
     * 订单编号
     */
    orderOriginalId?: string;
    /**
     * 发货成功的包裹
     */
    packageInfos?: PackageInfo[];
    /**
     * 状态
     */
    status?: ScanShippingResultStatus;
}

/**
 * 扫描发货接口
 * 生成的记录需要手动填充前端值
 */
export async function scanShippingShip(shopId: number, orderShipParams: OrderShipParams) {
    return post<ScanShippingResult[]>(shopId, "/scan_shipping/ship", orderShipParams, {
        hideModal: true,
    });
}
